exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bc-placeholders[data-v-0649d83d]{display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin:0 0 12px}.bc-placeholders__label[data-v-0649d83d]{font-size:12px;font-weight:600;color:#3a424e}.bc-placeholder[data-v-0649d83d]{display:inline-flex;align-items:center;padding:2px 10px;border-radius:999px;background:#eef3ff;border:1px solid #c7d6fe;color:#1b59f8;font-size:12px;font-family:monospace;cursor:grab;user-select:none}.bc-placeholder[data-v-0649d83d]:active{cursor:grabbing}.bc-placeholders__hint[data-v-0649d83d]{font-size:12px;color:#4e5560}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0649d83d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/broadcast/placeholderChips.vue
// module id = 929
// module chunks = 0